'use client';
import React, { ReactNode } from 'react';
import Container from '@elements/container';
import { Breadcrumbs, Div, Text, Media } from '@pezeshk-book/ui-kit';
import routes from '@routes';
import ClientDashboardMenu from '@desktop/client-dashboard/components/menu';
import classNames from '@utils/helpers/class-names';
import { useParams } from 'next/navigation';
import getParseRoute from '@utils/helpers/parse-route';
import getDictionary from '@dictionaries-client';
import { LocaleTypes } from '@dictionaries-types';

const ClientDashboardLayout = ({ children, section, className } : {children: ReactNode, section: string, className?:string}) => {
  const { lang } = useParams<{ lang : LocaleTypes }>();
  const { dashboard, home } = getDictionary(lang);

  return (
    <Container className={classNames(
      'flex-col gap-6 ',
      className,
    )}>
      <Breadcrumbs
        color={'tertiary'}
        dir={lang === 'fa' ? 'rtl' : 'ltr'}
        homeTitle={home.label}
        breadcrumbsData={[
          {
            label: dashboard.label,
            path: getParseRoute({ pathname: routes['route.client.dashboard'], locale: lang }),
          },
          {
            label: section,
          },
        ]}
      />
      <Text type={'bold'} align={'start'} variant={'h1'} typography={'xl'} color={'grey.900'}>{section}</Text>
      <Div className={'flex-col md:flex-row-reverse justify-between w-full'}>
        {children}
        <Media greaterThan={'sm'} className={'basis-4/12 relative'}>
          <ClientDashboardMenu/>
        </Media>
      </Div>
    </Container>
  );
};

export default ClientDashboardLayout;
